export const SETTINGS_KEYS = {
  LAST_ORDERS_ROUTE: 'lastOrdersRoute',
  AUTH_USER: 'authUser',
} as const;

export type SettingsKey = typeof SETTINGS_KEYS[keyof typeof SETTINGS_KEYS];
